import * as api from '../../constants/api'
import callApi from '../http'

const tankerRepairAdd = async (body) => await callApi(api.TANKER_REPAIR_ADD, body)

const tankerRepairByOperator = async (body) => await callApi(api.TANKER_REPAIR_LIST, body)

export {
    tankerRepairAdd,
    tankerRepairByOperator,
}